var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "393.000000pt",
    height: "302.000000pt",
    viewBox: "0 0 393.000000 302.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,302.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1821 2504 c-71 -19 -175 -74 -233 -124 -62 -54 -140 -172 -169 -257 -21 -58 -24 -87 -24 -203 0 -212 52 -386 165 -559 130 -198 313 -344 532 -426 l48 -18 -32 -59 c-62 -116 -200 -232 -331 -278 -87 -31 -258 -38 -346 -15 -214 56 -391 231 -445 442 -14 53 -16 157 -16 757 l0 696 -190 0 -191 0 3 -732 c3 -716 4 -735 25 -810 104 -367 358 -621 721 -720 114 -31 352 -31 476 0 302 76 561 301 677 586 l36 90 76 13 c383 64 684 369 746 753 6 37 11 228 11 443 l0 377 -190 0 -190 0 0 -383 c0 -420 -2 -435 -61 -548 -35 -65 -105 -141 -172 -188 -51 -34 -171 -84 -181 -74 -3 4 -6 179 -6 389 0 380 0 384 -25 461 -56 178 -200 322 -380 379 -89 28 -245 32 -334 8z m265 -389 c27 -16 54 -43 71 -73 l28 -47 3 -342 c2 -279 1 -343 -10 -343 -33 0 -146 82 -218 156 -123 128 -189 283 -191 445 -1 58 4 86 19 115 60 116 187 154 298 89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78b23d3481fa9e071592add9e655275c.svg";
export { ForwardRef as ReactComponent };